import React from 'react';
import { navigate } from '@reach/router';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

interface RedirectCustomPageProps {
  redirectPageText: string | null;
  redirectPageUrl: string | null;
}

const RedirectCustomPage: React.FC<RedirectCustomPageProps> = ({
  redirectPageText,
  redirectPageUrl
}) => {
  const { t } = useTranslation(
    ['View+Application+Stages', 'View+Application+Stages+Details+Footer'],
    { i18n }
  );

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';

  return (
    <div className="RedirectPageContent">
      <div
        className="Paragraphs"
        dangerouslySetInnerHTML={{ __html: redirectPageText ? redirectPageText : "" }}
      ></div>
      <button
        className={`Btn CloseApplicationBtn ${
          currentWebskin === 'defaultTheme' ? 'BtnPrimary' : 'BtnSecondary'
        } LrgBtn`}
        onClick={() => redirectPageUrl && navigate(redirectPageUrl)}
      >
        {t('SSCandidate_View_Application_Stages_Redirect')}
      </button>      
    </div>
  );
};

export { RedirectCustomPage };
